export default "__VITE_ASSET__BikVxvnR__"